var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fixed w-full -m-0.3 z-12"},[_c('HorizontalNav',{attrs:{"navs":_vm.tabs,"disabled":false}})],1),_c('div',{},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }